import { jsx as _jsx } from "react/jsx-runtime";
import { CircularProgress } from "@mui/material";
export const Loading = () => (_jsx(CircularProgress, { sx: {
        position: "absolute",
        top: "50%",
        left: "50%",
        margin: "-20px",
    } }));
//# sourceMappingURL=Loading.js.map